// Auth
export const ACHECKAUTH = 'CHECKAUTH'
export const ALOGIN = 'LOGIN'
